import { useQuery } from '@tanstack/react-query';
import { tenantApi } from '../services/tenantApi';

export interface Role {
  /** Numeric, as GET /api/roles and the openapi Role return it. */
  id: number;
  name: string;
  guard_name: string;
}

export const useRoles = () => {
  return useQuery({
    queryKey: ['roles'],
    queryFn: () => tenantApi.getList<Role>('/roles'),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
